export const tabsIndexes = {
  artists: 0,
  finalists: 1
}